import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-black text-white pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 pb-14 border-b border-white/10">
          <div>
            <p className="text-xs tracking-[0.25em] uppercase text-neutral-400 mb-4">
              hiremestudio.com
            </p>
            <h3 className="display text-[38px] sm:text-[48px] md:text-[80px] leading-[0.95]">
              Let&apos;s make <br />
              <span className="text-[#FFE14D]">something</span> great.
            </h3>
          </div>
          <a
            href="#contact"
            className="h-14 pl-7 pr-2 rounded-full bg-[#FFE14D] text-black text-base font-semibold hover:bg-white transition-colors flex items-center gap-3 group w-fit"
          >
            Start a Project
            <span className="w-11 h-11 rounded-full bg-black text-white flex items-center justify-center group-hover:rotate-45 transition-transform">
              <ArrowUpRight size={18} />
            </span>
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 pt-14">
          <div className="col-span-2">
            <p className="display text-2xl font-extrabold">
              HireMe<span className="handwritten text-[#FFE14D] ml-1">studio</span>
            </p>
            <p className="text-neutral-400 text-sm mt-3 max-w-xs leading-relaxed">
              Freelance WordPress, Shopify &amp; WooCommerce developer helping
              brands launch beautiful websites that sell.
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest text-neutral-500 mb-4">
              Menu
            </p>
            <ul className="space-y-2 text-sm">
              {["Work", "Services", "About", "Contact"].map((l) => (
                <li key={l}>
                  <a
                    href={`#${l.toLowerCase()}`}
                    className="text-neutral-300 hover:text-[#FFE14D] transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest text-neutral-500 mb-4">
              Services
            </p>
            <ul className="space-y-2 text-sm">
              {["WordPress Development", "Shopify Development", "WooCommerce Development", "UI/UX Design"].map((l) => (
                <li key={l}>
                  <a
                    href="#services"
                    className="text-neutral-300 hover:text-[#FFE14D] transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-neutral-500">
          <p>© {new Date().getFullYear()} Hire Me Studio · Crafted by Prince Khedkar</p>
          <p>All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
